type ValueControl = HTMLInputElement | HTMLSelectElement

export const reconcileControlledValue = (control: ValueControl, getAcceptedValue: () => string) => {
  requestAnimationFrame(() => {
    const acceptedValue = getAcceptedValue()

    if (control.value !== acceptedValue) {
      control.value = acceptedValue
    }
  })
}
